
import firebaseApp from '../firebase/init'
import Component, { mixins } from 'vue-class-component'
import mixin from '../mixin'
import { db } from '@/main'

@Component
export default class Login extends mixins(mixin) {
  btnDisable = false
  email = ''
  password = ''
  mounted() {
    console.log('Mounted')
    console.log(this.$route)
    console.log(window.location.href)
    this.loadFields()
  }

  async login() {
    this.btnDisable = true
    this.showNotification(
      'loading',
      'Cargando',
      'Estamos verificando tu identidad',
      0
    )
    try {
      const user = await firebaseApp
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)

      const doc = await db
        .collection('admins')
        .doc(user?.user?.uid)
        .get()

      if (doc.exists) {
        this.showNotification(
          'loading',
          'Iniciando sesión...',
          'Información correcta',
          0
        )
        const adminData = doc.data()
        this.$store.state.user.uid = user?.user?.uid
        this.$store.state.user.type = 'admin'
        this.$store.state.user.subType = adminData?.type || 'ADMINISTRADOR'
        this.$store.state.user.data = adminData || {}
        // A full navigation avoids the competing router transitions triggered
        // by Firebase's auth-state callback during this legacy login flow.
        const dashboardUrl = window.location.href.replace(
          /#.*$/,
          '#/dashboard-admin'
        )
        window.location.assign(dashboardUrl)
      } else {
        const clientDoc = await db
          .collection('client_employees')
          .doc(user?.user?.uid)
          .get()

        if (clientDoc.exists) {
          this.showNotification(
            'info',
            'Aviso',
            'Para ingresar como cliente debe ser con alguno de tus usuarios creados',
            10000
          )
        } else {
          this.showNotification(
            'info',
            'Aviso',
            'Para ingresar como colaborador debes descargar la aplicación',
            10000
          )
        }
      }
    } catch (error) {
      // Handle Errors here.
      const errorCode = (error as any).code
      const errorMessage = (error as any).message

      console.log(errorCode)
      console.log(errorMessage)
      // ...
      if (errorCode === 'auth/user-not-found') {
        this.btnDisable = false
        this.showNotification('fail', 'Error', 'El usuario no existe', 2000)
      } else if (errorCode === 'auth/invalid-email') {
        this.btnDisable = false
        this.showNotification(
          'fail',
          'Error',
          'El correo electrónico no es válido.',
          2000
        )
      } else if (errorCode === 'auth/wrong-password') {
        this.btnDisable = false
        this.showNotification(
          'fail',
          'Error',
          'La contraseña no es válida.',
          2000
        )
      } else {
        this.btnDisable = false
        this.showNotification(
          'fail',
          'Error',
          'Ocurrió un error. Intenta nuevamente.',
          2000
        )
        console.log('Sign in error:' + error)
      }
    }
  }
}
